export default "__VITE_ASSET__7f61c1ec__"